import { GoogleBusinessConnectionOptions } from '../../../../../modals/live-orders/LiveOrdersDrawer';

export default {
  titles: {
    disable: 'Sei sicuro di voler disabilitare gli ordini live?',
    enable: 'Sei sicuro di voler attivare gli ordini live?',
  },
  form: {
    delivery_app_sales_at_go_live: {
      label: 'Vendite mensili sulle app di delivery',
      description:
        'Vendite mensili totali su tutte le app di delivery (Lieferando, Wolt, Uber Eats …), come importo intero. Inserisci 0 se il ristorante non vende su nessuna. Dopo il go-live, solo un amministratore può modificarlo.',
      placeholder: 'Inserisci l’importo mensile',
    },
    is_google_business_available: {
      label: 'Google Business disponibile',
    },
    is_smart_pricing_configured: {
      label: 'Prezzi più bassi di Lieferando, Wolt, Uber',
    },
    is_flyers_package_sent: {
      label: 'Volantino promozionale inviato',
    },
    is_menu_fully_configured: {
      label: 'Tutti gli articoli del menu disponibili',
    },
    has_offers_on_competitor_platforms: {
      label: 'Il ristorante ha offerte attive su Wolt, Uber, Lieferando (esclusa offerta consegna gratuita)?',
    },
    is_instagram_story_shared: {
      label: 'Storia Instagram condivisa con il proprietario',
    },
    is_order_system_connected_to_website: {
      label: 'Sito web Foodamigos collegato OPPURE pulsante ordine online sul sito del ristorante aggiunto',
    },
    google_business_connected_by: {
      label: 'Come abbiamo ottenuto accesso al Profilo Google Business?',
      options: {
        [GoogleBusinessConnectionOptions.SalesManagerOverEmail]:
          'Il responsabile vendite ha invitato google@foodamigos.io',
        [GoogleBusinessConnectionOptions.SalesManagerOverPhone]:
          'Il responsabile vendite ha inviato la prima richiesta dal telefono del proprietario',
        [GoogleBusinessConnectionOptions.OnboardingManagerOverEmail]:
          "Il responsabile onboarding ha richiesto il profilo Google Business (il SM non ha invitato né richiesto l'accesso)",
      },
    },
  },
  labels: {
    successful_launch:
      'Per garantire un lancio ottimale, rivedi e risolvi i seguenti punti aperti. La verifica \n' +
      'di queste informazioni aiuterà a evitare potenziali problemi una volta che il ristorante sarà attivo.',
    check_errors: 'Controlla gli errori per garantire un buon lancio del ristorante.',
    checkbox_confirmation: "Confermo di aver esaminato gli errori e acconsento all'attivazione di questo ristorante.",
  },
  buttons: {
    check_error: 'Controlla errore',
    confirm_and_activate: 'Conferma e attiva',
    cancel: 'Annulla',
    yes: 'Sì',
    no: 'No',
  },
  errors: {
    name: {
      title: 'Nessun carattere arabo, cinese ecc. nel nome del negozio',
      description: 'Il nome del negozio online contiene caratteri non inglesi (non latini)',
    },
    logo_url: {
      title: 'Logo',
      description: 'Il logo è stato caricato nel negozio online',
    },
    pictures: {
      title: 'Immagine galleria',
      description: '≥ 1 immagine della galleria disponibile nel negozio online',
    },
    menu_uploaded: {
      title: 'Menu caricato',
      description: '≥ 1 menu disponibile',
    },
    opening_hours: {
      title: 'Orari di apertura',
      description: '≥ 1 orario di apertura aggiunto',
    },
    address: {
      title: 'Indirizzo del ristorante',
      description: 'Via, città, CAP inseriti',
    },
    upsell_items: {
      title: 'Articoli upsell',
      description: '≥ 3 articoli upsell selezionati',
    },
    master_promo_code: {
      title: 'Codice promo principale',
      description: 'Codice promo principale disponibile',
    },
    flyers_ordered: {
      title: 'Volantini ordinati',
      description: '≥ 1 pacchetto di volantini ordinato',
    },
    test_orders: {
      title: 'Ordine di prova inviato',
      description: '≥ 1 ordine di prova effettuato',
    },
    stripe_billing: {
      title: 'Account Stripe',
      description: 'Account Stripe collegato',
    },
    payments_configured: {
      title: 'Pagamenti configurati',
      description: 'Il partner ha collegato un provider di pagamento — obbligatorio prima di andare live',
    },
    adyen_merchant_account: {
      title: 'Account commerciante Adyen',
      description:
        'Un account commerciante attivo per il paese di questo ristorante — richiesto per le tariffe carte nazionali',
    },
    payment_rail_covers_country: {
      title: 'Il canale di pagamento copre il paese',
      description: 'Gli account di pagamento del partner possono elaborare il paese di questo ristorante',
    },
    identity: {
      title: 'Identità del ristorante',
      description: 'Tipo di ristorante e cucina impostati',
    },
    storefront: {
      title: 'Storefront creato e dominio collegato',
      description: 'Solo se il ristorante vuole usare il nostro sito web',
    },
    google_business: {
      title: 'Google Business',
      description: 'Google Business collegato',
    },
    billing_payment_method: {
      title: 'Metodo di pagamento',
      description:
        'Aggiungi un metodo di pagamento per consentire a FoodAmigos di fatturare mensilmente a questo ristorante.',
    },
    billing_license: {
      title: 'Licenza',
      description: 'Questo ristorante ha bisogno di un Partner Plan prima di poter andare live.',
    },
    business_name: {
      title: "Nome dell'azienda / del ristorante",
      description: "Il nome mostrato nelle condizioni d'uso e nell'informativa sulla privacy è stato salvato",
    },
    payment_method: {
      title: 'Pagamenti in contanti o online',
      description: 'Il contrassegno per ritiro o consegna è attivo, oppure i pagamenti online sono verificati',
    },
    stripe_processing_fee: {
      title: 'Commissione di elaborazione',
      description: 'Il partner ha impostato la commissione di elaborazione Stripe o ha confermato un margine dello 0%',
    },
  },
};
